<script>
import request from '@/libs/request'
import { BCard, BFormGroup, BFormInput, BButton, BForm } from 'bootstrap-vue'
export default {
  components: {
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton
  },
  data () {
    return {
      formError: '',
      password: '',
      passwordConfirmation: ''
    }
  },
  methods: {
    logout () {
      localStorage.setItem('avatar', '')
      this.$cookies.remove('session')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/')
    },
    handleSubmit () {
      if (!this.password.match('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#.$%^&+=])(?=\\S+$).{8,}$')) {
        this.formError = 'El formato es incorrecto'
        return undefined
      }

      if (this.password !== this.passwordConfirmation) {
        this.formError = 'Las contraseñas no coinciden'
        return undefined
      }

      request({
        url: 'users/password/update',
        method: 'PUT',
        params: {
          newPass: this.password
        }
      }).then(this.logout)
    }
  }
}
</script>
<template>
  <div>
    <h5>Antes de continuar es necesario que cambies tu contraseña</h5>
    <b-card class="mt-2">
      <b-form @submit.prevent="handleSubmit">
      <section class="" style="gap: 2rem;">
        <b-form-group
          label="Nueva contraseña"
          label-for="password"
          description="La contraseña debe contener al menos 8 caracteres, 1 mayúscula, 1 minúscula, 1 número y un caracter especial @ # $% ^ & + ="
        >
          <b-form-input v-model="password" id="password" type="password" required autocomplete="new-password"/>
        </b-form-group>
        <b-form-group
          label="Confirmar contraseña"
          label-for="password-confirm"
        >
          <b-form-input v-model="passwordConfirmation" id="password-confirm" type="password" required autocomplete="new-password"/>
        </b-form-group>
      </section>
      <p class="text-danger">{{ formError }}</p>
      <b-button class="mt-2" type="submit" variant="primarySpore">Actualizar</b-button>
    </b-form>
    </b-card>
  </div>
</template>
